import { useTranslation } from "@outschool/localization";
import {
  favoritesPath,
  learnerProfilesPath,
  transactionsPath,
  transcriptsPath,
  websiteHomePath,
} from "@outschool/routes";
import { useFeatureFlag } from "@outschool/ui-components-shared";

export default function useDashboardLinks() {
  const { t } = useTranslation(
    "client\\components\\parentDashboardV2\\hooks\\useDashboardLinks",
  );

  const showFavorites = useFeatureFlag("nav-pod-move-favorites-to-dashboard");

  return [
    {
      label: t("Classes"),
      to: websiteHomePath(),
    },
    ...(showFavorites
      ? [
          {
            label: t("Favorites"),
            to: favoritesPath(),
          },
        ]
      : []),
    {
      label: t("Transcripts"),
      to: transcriptsPath(),
    },
    {
      label: t("Transactions"),
      to: transactionsPath(),
    },
    {
      label: t("Learner Profiles"),
      to: learnerProfilesPath(),
    },
  ] as const;
}
